import { apiDate } from '@/platform/lib/utils';
import { Button, Form, FormGroup, Input, Select } from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';
import SidePanel from './SidePanel';

const NoRiskEntitlementPanel = ({ entitlement, onClose }) => {
    const { employee, reasons } = usePage().props;

    const { data, setData, post, patch, processing, errors } = useForm({
        reason: entitlement?.reason ?? '',
        start_date: apiDate(entitlement?.start_date) ?? '',
        end_date: apiDate(entitlement?.end_date) ?? '',
    });

    const baseUrl = `/customers/${employee.customer_id}/employees/${employee.id}/no-risk`;

    const handleSubmit = event => {
        event.preventDefault();

        const options = {
            reset: ['employee', 'navigation'],
            preserveScroll: true,
            onSuccess: onClose,
        };

        entitlement
            ? patch(`${baseUrl}/${entitlement.id}`, options)
            : post(baseUrl, options);
    };

    return (
        <SidePanel
            title={
                entitlement
                    ? 'No-riskperiode wijzigen'
                    : 'No-riskperiode toevoegen'
            }
            subtitle='Velden met * zijn verplicht.'
            onClose={onClose}
            footer={
                <div className='flex justify-end gap-2'>
                    <Button type='button' onClick={onClose}>
                        Annuleren
                    </Button>
                    <Button
                        type='submit'
                        form='no-risk-entitlement'
                        variant='primary'
                        loading={processing}
                    >
                        {entitlement ? 'Wijzigingen opslaan' : 'Toevoegen'}
                    </Button>
                </div>
            }
        >
            <Form id='no-risk-entitlement' onSubmit={handleSubmit}>
                <FormGroup>
                    <Select
                        label='Reden'
                        description='Op basis waarvan de werknemer onder de no-riskpolis valt.'
                        placeholder='Kies een reden'
                        required
                        value={data.reason}
                        onChange={event =>
                            setData('reason', event.target.value)
                        }
                        options={reasons}
                        error={errors.reason}
                    />
                    <Input
                        type='date'
                        label='Startdatum'
                        required
                        value={data.start_date}
                        onChange={event =>
                            setData('start_date', event.target.value)
                        }
                        error={errors.start_date}
                    />
                    <Input
                        type='date'
                        label='Einddatum'
                        description='Laat leeg als de periode doorloopt.'
                        value={data.end_date}
                        onChange={event =>
                            setData('end_date', event.target.value)
                        }
                        error={errors.end_date}
                    />
                </FormGroup>
            </Form>
        </SidePanel>
    );
};

export default NoRiskEntitlementPanel;
